enum EmitContext {
  CHAT = 'chat',
  EMOJI = 'emoji',
  POLL = 'poll',
  BATCH = 'batch',
  CONNECTED = 'connected',
  RECONNECT = 'reconnect',
  DISCONNECT = 'disconnect',
  SCHEDULE = 'schedule',
  DOUBT_SOLUTION = 'doubt_solution',
}
enum ChatEvents {
  ADD = 'add',
  ENABLE = 'enable',
  DISABLE = 'disable',
  DELETE = 'delete',
  SCHEDULE_CHAT_BLOCK = 'schedule_chat_block',
  SCHEDULE_CHAT_UNBLOCK = 'schedule_chat_unblock',
  USER_BLOCK = 'block',
  PIN_CHAT = 'pin',
  UNPIN_CHAT = 'unpin',
  PROFANE_WARN = 'profane_warn',
}

enum BatchEvents {
  BATCH_CHAT_BLOCK = 'chat_block',
  BATCH_CHAT_UNBLOCK = 'chat_unblock',
}

enum EmojiEvents {
  RECEIVE = 'RECEIVE',
  TRENDING = 'TRENDING',
  UPDATES = 'UPDATES',
  CONFIG = 'CONFIG',
}

enum ScheduleEvents {
  RESCHEDULED = 'rescheduled',
  SLIDE = 'slide',
  SCHEDULE_COMPLETE = 'SCHEDULE_COMPLETE',
  TOGGLE_LOW_DATA_MODE = 'TOGGLE_LOW_DATA_MODE',
}

export { BatchEvents, ChatEvents, EmitContext, EmojiEvents, ScheduleEvents };
